import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import { ISucessErrorDialogProps } from "./SuccessErrorDialog.types";
import {
  CheckCircleOutline,
  ErrorOutline,
  InfoOutlined,
  WarningAmberRounded,
} from "@mui/icons-material";
import { CSS_CONSTANTS } from "../../../constants/cssConstants";

export const SuccessErrorDialog: React.FC<ISucessErrorDialogProps> = (
  props
) => {
  const { open, content, type, onClose,  } = props;
  const theme = useTheme();;

  // Define colors and styles for each type
  const getTypeConfig = () => {
    switch (type) {
      case "success":
        return {
          primaryColor: theme.palette.success.main,
          backgroundColor: theme.palette.success.main,
          icon: CheckCircleOutline,
          title: "Success!",
          buttonText: "Continue",
          buttonVariant: "double" as const,
        };
      case "error":
        return {
          primaryColor: theme.palette.error.main,
          backgroundColor: theme.palette.error.main,
          icon: ErrorOutline,
          title: "Something went wrong",
          buttonText: "OK",
          buttonVariant: "double" as const,
        };
      case "warning":
        return {
          primaryColor: theme.palette.warning.main,
          backgroundColor: theme.palette.warning.main,
          icon: WarningAmberRounded,
          title: "Warning",
          buttonText: "Understood",
          buttonVariant: "double" as const,
        };
      case "info":
        return {
          primaryColor: theme.palette.info.main,
          backgroundColor: theme.palette.info.light,
          icon: InfoOutlined,
          title: "Information",
          buttonText: "Got it",
          buttonVariant: "double" as const,
        };
      default:
        return {
          primaryColor: theme.palette.primary.main,
          backgroundColor: theme.palette.primary.main,
          icon: InfoOutlined,
          title: "Notice",
          buttonText: "OK",
          buttonVariant: "double" as const,
        };
    }
  };

  const config = getTypeConfig();
  const IconComponent = config.icon;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "4px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
        },
      }}
    >
      <DialogContent sx={{ p: 0, position: "relative", backgroundColor: "#f5f5f5" }}>
        {/* Content Container */}
        <Box sx={{ p: 3,pt: 4, backgroundColor: "white" }}>
          <Stack direction="row" spacing={2} alignItems="center">
            {/* Icon */}
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              sx={{
                minWidth: 50,
                minHeight: 50,
                mt: 0.5,
              }}
            >
              <IconComponent
                sx={{
                  color: config.primaryColor,
                  fontSize: 40,
                }}
              />
            </Box>

            <Box sx={{ flex: 1 }}>
              <Typography
                variant="body1"
                color={theme.palette.text.primary}
                sx={{
                  fontSize: CSS_CONSTANTS.LABEL_HEADING_SIZE,
                }}
              >
                {content}
              </Typography>

            
            </Box>
          </Stack>
        </Box>

        
        <Box
          sx={{
            p: 1,
            px: 3,
            backgroundColor: "#f5f5f5",
            display: "flex",
            justifyContent: "flex-end",
            borderTop: `1px solid ${theme.palette.divider}`,
          }}
        >
          {config.buttonVariant === "double" ? (
            <Stack direction="row" spacing={2}>
            
              <Button
                variant="contained"
                onClick={onClose}
                sx={{
                  minWidth: 100,
                 
                  borderRadius: "2px",
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: "0.875rem",
                  backgroundColor: config.primaryColor,
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor:
                      type === "error"
                        ? theme.palette.error.main
                        : config.primaryColor,
                    boxShadow: "none",
                  },
                }}
              >
                {config.buttonText}
              </Button>
            </Stack>
          ) : (
            <Button
              variant="contained"
              onClick={onClose}
              sx={{
                minWidth: 100,
                px: 4,
                py: 1,
                borderRadius: "2px",
                textTransform: "none",
                fontWeight: 500,
                fontSize: "0.875rem",
                backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[600] : theme.palette.grey[700],
                color: "white",
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[600] : theme.palette.grey[800],
                  boxShadow: "none",
                },
              }}
            >
              OK
            </Button>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};
